export default __webpack_public_path__ + "static/media/mobile_containts-44.215cf18b.png";